import { createContext } from 'react'

import { FiltersContextValueType } from './FiltersContext.types'

export const FiltersContext = createContext<FiltersContextValueType | undefined>(undefined)
